import './SwapCardProfileLink.scss';
import { FC } from 'react';
interface SwapCardProfileLinkProps {
	text?: string;
	style?: string;
	slug?: string;
	exhibitor_id?: string;
}
const swapcardDomain = import.meta.env.VITE_SWAPCARD_LIVE_EVENT;

const handleSwapcardProfileLink = (slug: string | undefined, exhibitor_id: string | undefined) => {
	const url = `https://${swapcardDomain}/event/${slug}/exhibitor/${exhibitor_id}`;
	window.open(url, '_blank', 'noopener');
};
export const SwapCardProfileLink: FC<SwapCardProfileLinkProps> = ({
	text,
	style,
	slug,
	exhibitor_id
}) => {
	return (
		<div
			data-testid='expo-label-component'
			className={`swapcard-profile-link ${style}`}
			onClick={() => handleSwapcardProfileLink(slug, exhibitor_id)}
		>
			<span id='expo-label-component' className={`text ${style}`}>
				{text}
				<i className='ri-arrow-right-s-line right-arrow icon'></i>
			</span>
		</div>
	);
};
